// TODO This list closely follows our "feature" list. Can we unify them?
// Probably want to centralize creative generators that combine feature,
// asset, text, cta, analytics, etc. all in one.
import { Locale } from '../replicant/ruleset/locale';
import StateObserver from '../StateObserver';
import { CreativeText } from '../replicant/creatives/text';
import { getRandomItemFromArray } from 'src/replicant/utils/random';

export type CreativeType = 'invite' | 'energy_gift';

type MessagesConfig = Record<
  'en' | 'ja',
  Record<
    CreativeType,
    Record<
      string,
      {
        text: string;
        cta: string;
      }
    >
  >
>;

const getConfig = (): MessagesConfig => ({
  en: {
    invite: {
      'en-invite_share': {
        text:
          'A New Kind of Pet Raising Game!\nNo download required, you can play right now!\nLet’s raise a cute pet with me together!',
        cta: 'Play now!',
      },
    },
    energy_gift: {
      'en-energy_gift': {
        text: 'I sent energy gift to you!!',
        cta: 'Play now!',
      },
    },
  },
  ja: {
    invite: {
      'ja-invite_share': {
        text:
          'めっちゃ可愛いゲーム見つけたよ\nぶるぶるどーぶつっていうペット育成ゲームなんだけど、LINEで遊べるから試してみて！',
        cta: '今すぐプレイ！',
      },
    },
    energy_gift: {
      'ja-energy_gift': {
        text: 'エネルギーおくったよ！',
        cta: '今すぐプレイ！',
      },
    },
  },
});

export function getCreativeText(
  type: CreativeType,
  substitutions?: { [key: string]: any },
  textId?: string,
  receiverLocale?: Locale,
): CreativeText {
  const locale =
    receiverLocale ?? StateObserver.getState().user.settings.locale;

  // Fall back to English if we don't have the current locale
  const config = getConfig();
  const messagesObj = config[locale]?.[type] || config.en[type];
  let messageId = '';

  // messages with 'unique' in their key should not be in rotation,
  // they supposed to go together with particular creative
  const messagesArr = Object.keys(messagesObj).filter(
    (key) => key.indexOf('unique') < 0,
  );

  // pick textId if it's passed, otherwise randomly select from existing keys
  messageId = textId || getRandomItemFromArray(messagesArr, Math.random);
  let message = messagesObj[messageId];

  // for unique messages, fallback to English version
  // if message is absent for this locale
  // if something is totally wrong, pick first from existing
  if (!message) {
    messageId = messageId.replace(locale, 'en');
    message =
      config.en[type][messageId] ||
      messagesObj[getRandomItemFromArray(messagesArr, Math.random)];
  }

  // TODO Type safety and all that goodness
  let text = message.text;
  if (substitutions) {
    for (const token in substitutions) {
      text = text.replace('{' + token + '}', substitutions[token]);
    }
  }

  return {
    id: messageId,
    cta: message.cta,
    text: text,
  };
}
